<div *ngIf="isAILegendSelected" class="panel panel-default col-sm-5">
    <div class="panel-heading">
        <h4>
            Edit AI Variable
        </h4>
    </div>
    <form (submit)="updateAIVar(); $event.stopPropagation()" #editAIVarForm="ngForm">
        <div class="panel-body">
            <fieldset>
                <div class="form-group">
                    <label class="col-sm-2 control-label">Name <label class="required"></label></label>
                    <div class="col-sm-10"> 
                        <input type="text" class="form-control" [(ngModel)]="selectedEditLegend.name" name="editName"
                            required> <span class="text-danger" *ngIf="!editAIVarForm.controls['editName'].valid">This
                            field is required</span>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <div class="form-group">
                    <label class="col-sm-2 control-label">Description <label class="required"></label></label>
                    <div class="col-sm-10">
                        <textarea class="form-control" rows="4" cols="50" [(ngModel)]="selectedEditLegend.description"
                            name="editDescription" required></textarea>
                        <span class="text-danger" *ngIf="!editAIVarForm.controls['editDescription'].valid">This
                            field is required</span>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <div class="form-group">
                    <label class="col-sm-2 control-label">Update Prompt <label class="required"></label></label>
                    <div class="col-sm-10">
                        <app-editor [htmlTemplate]="emailText"
                            (templateChanged)="onTemplateChange($event)"></app-editor>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <div class="form-group">
                    <label class="col-sm-2 control-label">Preview <label class="required"></label></label>
                    <div class="col-sm-10">
                        <textarea class="form-control" readonly rows="4" cols="50"
                            [(ngModel)]="selectedEditLegend.preview" name="editPreview"></textarea>
                    </div>
                </div>
            </fieldset>
        </div>

        <div class="panel-footer text-center">
            <button class="btn btn-default" type="button" (click)="this.selectedEditLegend = null">Cancel</button>
            <button class="btn btn-info" type="submit" [disabled]="!editAIVarForm.form.valid">Save</button>
        </div>
    </form>
</div>